module.exports = __webpack_public_path__ + "media/images/shared/delivery/jde-1b986fb66ea230f73c645342d23824d1.png";